<template>
  <BaseButton @click="$emit('click')" :variant="variant" :disabled="disabled">
    <b-icon-plus scale="1.6"></b-icon-plus><slot></slot>
  </BaseButton>
</template>

<script>
import { BIconPlus } from 'bootstrap-vue';
import buttonMixin from '@/mixins/button';

export default {
  mixins: [buttonMixin],
  components: {
    'b-icon-plus': BIconPlus,
  },
  props: {
    variant: { type: String, default: 'primary' },
    disabled: { type: Boolean },
  },
};
</script>
